import React from 'react'
import { Portlet } from '_zari/core'
import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import { IdGen } from 'utils'
import * as InventarioService from 'services/inventario.service'
import MainForm from './mainForm'

const NuevoSaldoInicial = ({ match }) => {
  const [__keyMainForm, setKeyMainForm] = React.useState(null)
  const [edicionInfo, setEdicionInfo] = React.useState({})

  const idDesdeRuta = match.params.id;

  const portletBreadcrumbs = React.useMemo(() => {
    if (idDesdeRuta) {
      return [
        {
          name: 'Entrada - Salida',
          path: `/${CodigosTransaccionesConstant.INVENTARIOS_ENTRADASALIDA_LISTA}`
        },
        { name: 'Edicion' }
      ]
    }
    return [
      {
        name: 'Entrada - Salida',
        path: `/${CodigosTransaccionesConstant.INVENTARIOS_ENTRADASALIDA_LISTA}`
      },
      { name: 'Nuevo' }
    ]
  }, [idDesdeRuta])

  React.useEffect(() => {
    if (idDesdeRuta) {
      // MODO EDICIÓN: Cargamos datos antes de mostrar el formulario
      InventarioService.obtenerxIdAsEdicion(idDesdeRuta)
        .then(({ data }) => {
          setEdicionInfo(data)
          setKeyMainForm(IdGen.newId()) // Remonta el MainForm con la data cargada
        })
        .catch(err => {
          console.error("Error cargando datos de edición", err)
          setKeyMainForm(IdGen.newId())
        })
    } else {
      // MODO NUEVO
      setEdicionInfo({})
      setKeyMainForm(IdGen.newId())
    }
  }, [idDesdeRuta])

  return (
    <Portlet>
      <Portlet.Header title='Inventarios' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        {__keyMainForm ? (
          <MainForm key={__keyMainForm} edicionInfo={edicionInfo} idRegistro={idDesdeRuta} />
        ) : (
          <div className="text-center p-5">
            <i className="fa fa-spinner fa-spin fa-2x mb-2"></i>
            <br /> Cargando información...
          </div>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default NuevoSaldoInicial